import { motion } from 'framer-motion';

interface ChapterIndicatorProps {
  act: string;
  subtitle?: string;
  light?: boolean;
  onDark?: boolean; // For dark colored backgrounds like the red CTA
}

const ChapterIndicator = ({ act, subtitle, light = false, onDark = false }: ChapterIndicatorProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="flex items-center gap-4 mb-6"
    >
      <span className={`font-cinzel text-sm tracking-[0.3em] uppercase ${onDark ? 'text-white' : 'text-punto'}`}>
        {act}
      </span>
      <div className={`w-12 h-px ${onDark ? 'bg-white/50' : 'bg-punto/50'}`} />
      {subtitle && (
        <span className={`text-sm tracking-wider ${onDark ? 'text-white/70' : light ? 'text-gray-500' : 'text-white/50'}`}>
          {subtitle}
        </span>
      )}
    </motion.div>
  );
};

export default ChapterIndicator;
